var map = {
	"./icon_tab1.svg": 87665,
	"./icon_tab1_active.svg": 66373,
	"./icon_tab2.svg": 17435,
	"./icon_tab2_active.svg": 49869,
	"./icon_tab3.svg": 12548,
	"./icon_tab3_active.svg": 62943,
	"./icon_tab4.png": 81948,
	"./icon_tab4_active.png": 52193,
	"./icon_tab5.svg": 37118,
	"./icon_tab5_active.png": 28023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15368;